import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import AulaUserContext, { setAulaSession } from '../aulaUserContext';

const AulaLogin = (props) => {
    const [email, setEmail] = useState('');
    const [contrasena, setContrasena] = useState('');
    const [error, setError] = useState('');
    const { setAulaAuth } = useContext(AulaUserContext);
    const from = (props.location.state && props.location.state.from) || '/aula';

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');

        fetch('/aula/auth/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify({ email, contrasena })
        }).then(async (res) => {
            if (res.status === 200) {
                const data = await res.json();
                setAulaSession(data);
                setAulaAuth({ token: data.token, nombre: data.nombre, rol: data.rol });
                props.history.push(from);
            } else if (res.status === 403) {
                props.history.push({ pathname: '/aula/confirmar', state: { email, from } });
            } else {
                setError('Email o contraseña incorrectos.');
            }
        });
    };

    return (
        <div className="container vh-100 text-center">
            <h3 className="title">Ingresar al Aula Virtual</h3>
            <div className="row">
                <div className="col-md-6 mx-auto">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder="Email" value={email}
                                onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" placeholder="Contraseña" value={contrasena}
                                onChange={(e) => setContrasena(e.target.value)} required />
                        </div>
                        <button type="submit" className="btn aula-btn-primary btn-block">Ingresar</button>
                        {error && <span className="d-block text-danger mt-2">{error}</span>}
                        <Link className="d-block mt-3" to={{ pathname: '/aula/registro', state: { from } }}>¿No tenés cuenta? Registrate</Link>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AulaLogin;
